/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Wild type
 */
export type ImportReportDtoWildType =
  (typeof ImportReportDtoWildType)[keyof typeof ImportReportDtoWildType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportReportDtoWildType = {
  freeRoaming: 'freeRoaming',
  captive: 'captive',
  feral: 'feral',
} as const;
